import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import WithdrawalToolsListTable from '../Table/WithdrawalToolsList';
//import * as Colors  from 'material-ui/styles/colors';
import { ClassName} from "mgToolsKit";
import { MGSiteButton } from 'mgUiKit';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WithdrawalToolsListComponent';

class WithdrawalTools extends React.Component {
    constructor(props, context) {
        super(props);
        this.openPage = this.openPage.bind(this);
    }
    
    openPage(){
        var body = <WithdrawalToolsListTable />;
        this.context.handleSetPage("Preleva dal conto gioco", body,true);
    }

    render(){
        var className = [];
        className.push("mg-user-widget--preleva");
        return(           
            <MGSiteButton
                title={AppSettings.urls.withDrawalTools.text}                
                class={ClassName(className)}
                label={AppSettings.urls.withDrawalTools.text}
                disabled={false}
                primary={false}
                isButton={true}
                fullWidth={false}
                actionFunc={this.openPage}                                                                       
            />
        )
    }
}

WithdrawalTools.displayName = componentName;

// PropTypes validation
WithdrawalTools.propTypes = {};

// default props
WithdrawalTools.defaultProps = {};

WithdrawalTools.contextTypes = {
    handleSetPage: PropTypes.func
}

export default WithdrawalTools;